module.exports = __webpack_public_path__ + "img/wallet.5bbb0ecc.svg";